/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import * as S from "./selectors";
import { ModuleId } from "../../globalTypes";
import { useFetchModuleMetadataCallback } from "./useActions";

export const useVisibleOverviewTemplateIdsForModule = (moduleId: number) => {
  const getIds = useMemo(
    S.makeGetIdsOfAllVisibleOverviewTemplatesForModuleId, // I <3 PRETTIER
    [moduleId]
  );

  return useSelector((state) => getIds(state, moduleId));
};

export const useIsMetadataFetchingForAllModules = () =>
  useSelector(S.getIsMetadataFetching);

export const useIsMetadataFetchingForModule = (moduleId: number) =>
  !!useSelector((state) => S.getIsMetadataFetchingForModuleId(state, moduleId));

export const useVisibleOverviewTemplateIdsForModuleAUTOFETCH = (
  moduleId: ModuleId
) => {
  const ids = useVisibleOverviewTemplateIdsForModule(moduleId);
  const isFetching = useIsMetadataFetchingForModule(moduleId);
  const fetchModuleMetadata = useFetchModuleMetadataCallback();

  useEffect(() => {
    if (ids.length === 0 && !isFetching) {
      fetchModuleMetadata(moduleId);
    }
  }, [moduleId]);

  return ids;
};

export const useTemplateIdsForModule = (moduleId: number) => {
  const moduleMetadata = useSelector((state) =>
    S.getMetadataForModuleId(state, moduleId)
  );

  return moduleMetadata?.templates ?? [];
};

export const useModuleMetadataFromId = (id: number) =>
  useSelector((state) => S.getMetadataForModuleId(state, id));

export const useModuleMetadataFromIdAUTOFETCH = (id: number) => {
  const fetchModuleMetadata = useFetchModuleMetadataCallback();

  const metadata = useModuleMetadataFromId(id);

  useEffect(() => {
    if (!metadata) fetchModuleMetadata(id);
  }, [id]);

  return metadata;
};

export const useAllModulesMetadata = () =>
  useSelector((state) => S.getAllModulesMetadataById(state));

export const useAllModulesNameAndOrder = () =>
  useSelector(S.getAllModulesNameAndOrder);

export const useModuleNameForModuleId = (
  moduleId: number
): string | undefined =>
  useSelector((state) => S.getNameForModuleId(state, moduleId));

export const useOrderedTemplatesForModuleId = (moduleId: number) =>
  useSelector((state) => S.getOrderedTemplatesByModuleId(state, moduleId));

export const useTemplateModuleMetadataById = (templateId: number) =>
  useSelector((state) => S.getTemplateModuleMetadataById(state, templateId));

export const useDataForTemplatesOrder = (moduleId: number) =>
  useSelector((state) => S.getDataForTemplatesOrder(state, moduleId));

export const useModuleIdForTemplateId = (templateId: number) =>
  useSelector((state) => S.getModuleIdByTemplateId(state, templateId));
